export default __webpack_public_path__ + "static/media/luv2.10a6c39b.mp3";